module.exports = __webpack_public_path__ + "static/img/infoCatering.d5e10ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/catering/infoCatering.jpg
// module id = T1+n
// module chunks = 1